// Личная частота переходов по меню: хранится в браузере сотрудника, по его учётной записи.
// Нет хранилища (приватное окно, запрет) — меню просто работает по стартовым весам роли.
import { ref, watch } from 'vue'
import { recordVisit } from './menuLogic.mjs'

const PREFIX = 'erp:menu-usage:v1:'

function read(key) {
  try { return JSON.parse(window.localStorage.getItem(key) || '{}') || {} } catch (e) { return {} }
}

function write(key, value) {
  try { window.localStorage.setItem(key, JSON.stringify(value)) } catch (e) { /* без хранилища */ }
}

export function useMenuUsage(userId) {
  const usage = ref({})
  const storageKey = () => PREFIX + (userId.value || 'anon')

  watch(userId, () => { usage.value = read(storageKey()) }, { immediate: true })

  function visit(menuKey) {
    if (!menuKey || !userId.value) return
    usage.value = recordVisit(usage.value, menuKey)
    write(storageKey(), usage.value)
  }

  return { usage, visit }
}
